export type ChallengeMediaPlaceholder = 'cover' | 'judge' | 'prize' | 'sponsor';

export function isHttpImageUrl(value: string | null | undefined): boolean {
  const trimmed = value?.trim();
  return !!trimmed && (trimmed.startsWith('http://') || trimmed.startsWith('https://'));
}

/** Prefer server-resolved display URL; fall back to stored absolute URL. Defaults come from the API. */
export function resolveChallengeMediaSrc(
  displayUrl: string | null | undefined,
  storedUrl: string | null | undefined,
  _placeholder?: ChallengeMediaPlaceholder
): string {
  if (isHttpImageUrl(displayUrl)) {
    return displayUrl!.trim();
  }
  if (isHttpImageUrl(storedUrl)) {
    return storedUrl!.trim();
  }
  return (displayUrl ?? storedUrl ?? '').trim();
}

export function onChallengeImageError(event: Event, _placeholder?: ChallengeMediaPlaceholder): void {
  const img = event.target as HTMLImageElement | null;
  if (!img) {
    return;
  }
  // Server owns defaults; hide broken images rather than swapping to local assets.
  img.style.visibility = 'hidden';
}